import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    downloadModal: false,
    sistema: "",
  },
  getters: {
    downloadModal: state => state.downloadModal,
    sistema: state => state.sistema,
  },
  mutations: {
    showDownloadModal(state, sistema) {
      state.sistema = sistema;
      state.downloadModal = true;
    },
    closeDownloadModal(state) {
      state.sistema = "";
      state.downloadModal = false;
    },
  },
  actions: {},
});
